import { feedbotToast } from '../../lib/feedbotToast'

export const toastNotifyBotMutationsUnselectedSuccess = () => {
  const id = 'mutationsUnselectSuccess'

  const title = 'Bot mutations unselected'

  const content =
    'We successfully reset your bot´s mutations, you can now add a step and continue with editing.'

  feedbotToast.success({ title, content, id })
}
